import { render, staticRenderFns } from "./UsesReport.vue?vue&type=template&id=9982928c&scoped=true"
import script from "./UsesReport.vue?vue&type=script&lang=js"
export * from "./UsesReport.vue?vue&type=script&lang=js"
import style0 from "./UsesReport.vue?vue&type=style&index=0&id=9982928c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9982928c",
  null
  
)

export default component.exports